export const GET_VEHICLE_DATA = 'GET_VEHICLE_DATA';
export const GET_VEHICLE_INFORMATION = 'GET_VEHICLE_INFORMATION';
export const GET_VEHICLE_DETAILS = 'GET_VEHICLE_DETAILS';
export const UPDATE_VEHICLE = 'UPDATE_VEHICLE';
